module.exports = "/2a0914223e35ccc7571270a298329b1a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/feature-3.png
 ** module id = 2213
 ** module chunks = 0
 **/